import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  user: { id?: string; name: string; email?: string; role: string; classId?: string | null } | null;
  token: string | null;
  tenant: { id: string; name: string; domain: string; subdomain: string } | null;
}

const stored = typeof window !== "undefined" ? localStorage.getItem("medu_auth") : null;
const initial: AuthState = stored ? JSON.parse(stored) : { user: null, token: null, tenant: null };

const slice = createSlice({
  name: "auth",
  initialState: initial,
  reducers: {
    setCredentials(
      state,
      action: PayloadAction<{ user: AuthState["user"]; token: string; tenant?: AuthState["tenant"] }>
    ) {
      state.user = action.payload.user;
      state.token = action.payload.token;
      if (action.payload.tenant) state.tenant = action.payload.tenant;
      localStorage.setItem("medu_auth", JSON.stringify(state));
    },
    logout(state) {
      state.user = null;
      state.token = null;
      state.tenant = null;
      localStorage.removeItem("medu_auth");
    },
  },
});

export const { setCredentials, logout } = slice.actions;
export default slice.reducer;
